export const STATUS_LABELS = {
  OPEN: 'Открыт',
  CLOSE: 'Закрыт',
  CLOSE_WITH_TRANSFER: 'Закрыт с переводом',
  OPEN_WITH_TRANSFER: 'Открыт с переводом',
};
